import { render, staticRenderFns } from "./NewsNav.vue?vue&type=template&id=76639d16&scoped=true"
import script from "./NewsNav.vue?vue&type=script&lang=js"
export * from "./NewsNav.vue?vue&type=script&lang=js"
import style0 from "./NewsNav.vue?vue&type=style&index=0&id=76639d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76639d16",
  null
  
)

export default component.exports